import dgss from "../images/dgss_logo.png"
import mcca from "../images/desautels_mcca_logo.jpg"
import vpsports from "../images/vpsports.jpg"
import umeed from "../images/umeed.png"
import React from 'react'

const blogConfig = [
    {
        id: "blog-3",
        title: "President - Lifestyle",
        links: [
            {
                name: "learn more",
                url: "https://www.mcgill.ca/desautels/students/desautels-graduate-student-society",
                icon: <span>🔗</span>
            }
        ],
        image: dgss,
        description: "Served as President of the Lifestyle Club at Desautels. Invigorated the community's sports and well-being culture, bolstering engagement and collaborative health initiatives.",
        target: "_blank"
    },
    {
        id: "blog-2",
        title: "VP Sports - MMA Internal Council",
        links: [
            {
                name: "learn more",
                url: "https://www.mcgill.ca/desautels/students/desautels-graduate-student-society",
                icon: <span>🔗</span>
            }
        ],
        image: vpsports,
        description: "Promoted physical fitness and strengthened peer bonds by organizing physical and e-sports opportunities to alleviate stress within the MMA community.",
        target: "_blank"
    },
    {
        id: "blog-1",
        title: "VP Events - MCCA",
        links: [
            {
                name: "learn more",
                url: "https://www.mcgill.ca/desautels/students/desautels-graduate-student-society",
                icon: <span>🔗</span>
            }
        ],
        image: mcca,
        description: "Lead the events portfolio for McGill's Master of Management in Analytics Student Society (MCCA).",
        target: "_blank"
    },
    {
        id: "blog-0",
        title: "Volunteer - Umeed",
        links: [
            {
                name: "learn more",
                url: "https://www.facebook.com/UmeedADropOfHope/",
                icon: <span>🔗</span>
            }
        ],
        image: umeed,
        description: "Volunteered at 'Umeed - A Drop of Hope' NGO in Delhi, where I taught Mathematics to underprivileged children, empowering them with essential educational skills for success.",
        target: "_blank"
    }
]

export default blogConfig
